<div class="skeleton-fulfillment-attribute-container">
	<div class="skeleton-fulfillment-section hmf-p-xs hmf-p-sm-s">
		<span class="hmf-body-s">Fulfillment</span>

		<div class="fulfillment-row hmf-display-flex hmf-mt-xxs hmf-mb-xxs hmf-pb-xxs hmf-pb-sm-0">
			<div class="gradient-icon skeleton-grey-loading-animation hmf-align-self-center hmf-mr-xxxs"></div>
			<div class="fulfillment-placeholder skeleton-grey-loading-animation"></div>
		</div>

		<div class="fulfillment-row hmf-display-flex hmf-pb-xs hmf-pb-sm-0">
			<div class="gradient-icon skeleton-grey-loading-animation hmf-align-self-center hmf-mr-xxxs"></div>
			<div class="fulfillment-placeholder skeleton-grey-loading-animation"></div>
		</div>
	</div>

	<div class="skeleton-attribute-section hmf-p-s">
		<div class="attribute-box">
			<div class="attribute-name-placeholder hmf-mb-xxs"></div>
			@for (item of [0,0,0,0,0]; track trackbyFn($index)) {
				<div class="attribute-value-placeholder skeleton-grey-loading-animation hmf-round-radius hmf-mb-xxxs"></div>
			}
		</div>
	</div>

	<div class="skeleton-attribute-section hmf-p-s">
		<div class="attribute-box">
			<div class="attribute-name-placeholder skeleton-grey-loading-animation hmf-mb-xxs"></div>
			<div class="square-attributes hmf-display-flex hmf-flex-wrap">
				@for (item of [0,0,0,0,0]; track trackbyFn($index)) {
					<div class="attribute-square-placeholder skeleton-grey-loading-animation"></div>
				}
			</div>
		</div>
	</div>
</div>
